import axios from "axios";
import { BaseUrl } from "../../server";

// load user
export const loadUser = () => async (dispatch) => {
  try {
    dispatch({
      type: "LoadUserRequest",
    });
    const { data } = await axios.get(`${BaseUrl}/user/getuser`, {
      withCredentials: true,
    });
    dispatch({
      type: "LoadUserSuccess",
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: "LoadUserFail",
      payload: error.response.data.message,
    });
  }
};


// load seller

// user update information
export const updateUserInformation =
  (name, email, phoneNumber, password) => async (dispatch) => {
    try {
      dispatch({
        type: "updateUserInfoRequest",
      });

      const { data } = await axios.put(
        `${BaseUrl}/user/update-user-info`,
        {
          email,
          password,
          phoneNumber,
          name,
        },
        {
          withCredentials: true,
          headers: {
            "Access-Control-Allow-Credentials": true,
          },
        }
      );

      dispatch({
        type: "updateUserInfoSuccess",
        payload: data.user,
      });
    } catch (error) {
      dispatch({
        type: "updateUserInfoFailed",
        payload: error.response.data.message,
      });
    }
  };


export const getAllUsers = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllUsersRequest",
    });

    const { data } = await axios.get(`${BaseUrl}/user/admin-all-users`, {
      withCredentials: true,
    });

    dispatch({
      type: "getAllUsersSuccess",
      payload: data.users,
    });
  } catch (error) {
    dispatch({
      type: "getAllUsersFailed",
      payload: error.response.data.message,
    });
  }
};
export const LogoutUser = () => async (dispatch) => {
  try {
    dispatch({
      type: "LogoutUserRequest",
    });
    const { data } = await axios.get(`${BaseUrl}/user/logout`, {
      withCredentials: true,
    });
    dispatch({
      type: "LogoutUserSuccess",
      payload: data.message,
    });

  } catch (error) {
    dispatch({
      type: "LogoutUserFail",
      payload: error.response.data.message,
    });
  }
};

export const getFillterUsers = (page , limit, phoneNumber, email,name) => async (dispatch) => {
  try {
  
      // إرسال طلب بدء جلب البيانات
      dispatch({ type: 'get_Fillter_users_request' });

      // إضافة Pagination إلى query parameters
      const { data } = await axios.get(`${BaseUrl}/user/filter`,
  {
          params: {
              page,
              limit,
              phoneNumber,
              email,
              name
          } ,
          withCredentials: true,
      })
  ;

      // إرسال البيانات بنجاح مع معلومات Pagination
      dispatch({
          type: 'get_Fillter_users_success',
          payload: {
              users: data.users,
              pagination: data.pagination,
              totalusers:data.totalusers // معلومات Pagination من الخادم
          },
      });

  } catch (error) {
      // إرسال خطأ في حالة فشل الطلب
      dispatch({
          type: "get_Fillter_users_error",
          payload: error.response?.data?.message || "حدث خطأ ما",
      });
  }
};

export const getUserById = (id) => async (dispatch) => {
  try {
     
      dispatch({ type: 'get_user_request' });

      const { data } = await axios.get(`${BaseUrl}/user/${id}`,{withCredentials:true});
    
      dispatch({ type: 'get_user_success' ,payload:data.user});

  } catch (error) {
      dispatch({
          type: "get_user_error",
          payload: error.response.data.message,
        });
  }
}